// Export an array of topics for VA 1st Grade Math
const md4thMathQuizContent = [
  {
    "slug": "placevalue",
    "title": "Place Value",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What is the value of the 5 in 4,572?",
        "answers": [
          { "text": "500", "correct": true },
          { "text": "50", "correct": false },
          { "text": "5,000", "correct": false }
        ]
      },
      {
        "question": "What is the value of the 7 in 7,824?",
        "answers": [
          { "text": "7,000", "correct": true },
          { "text": "700", "correct": false },
          { "text": "70", "correct": false }
        ]
      },
      {
        "question": "Each place value to the left is how many times greater?",
        "answers": [
          { "text": "10 times greater", "correct": true },
          { "text": "5 times greater", "correct": false },
          { "text": "2 times greater", "correct": false }
        ]
      },
      {
        "question": "What is the value of the 3 in 53,219?",
        "answers": [
          { "text": "3,000", "correct": true },
          { "text": "300", "correct": false },
          { "text": "30,000", "correct": false }
        ]
      },
      {
        "question": "What happens to a digit’s value when it moves one place to the right?",
        "answers": [
          { "text": "It becomes 10 times smaller", "correct": true },
          { "text": "It becomes 10 times greater", "correct": false },
          { "text": "It stays the same", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "comparefractions",
    "title": "Compare Fractions",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "Which fraction is greater: 3/4 or 2/4?",
        "answers": [
          { "text": "3/4", "correct": true },
          { "text": "2/4", "correct": false },
          { "text": "They are equal", "correct": false }
        ]
      },
      {
        "question": "Which fraction is less: 1/3 or 2/3?",
        "answers": [
          { "text": "1/3", "correct": true },
          { "text": "2/3", "correct": false },
          { "text": "They are equal", "correct": false }
        ]
      },
      {
        "question": "If two fractions have the same denominator, which number do we compare?",
        "answers": [
          { "text": "The numerators", "correct": true },
          { "text": "The denominators", "correct": false },
          { "text": "The whole numbers", "correct": false }
        ]
      },
      {
        "question": "Which is greater: 2/6 or 4/6?",
        "answers": [
          { "text": "4/6", "correct": true },
          { "text": "2/6", "correct": false },
          { "text": "They are equal", "correct": false }
        ]
      },
      {
        "question": "Which pair of fractions are equal?",
        "answers": [
          { "text": "1/2 and 2/4", "correct": true },
          { "text": "1/3 and 1/4", "correct": false },
          { "text": "2/3 and 3/4", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "addsubtractfractions",
    "title": "Add & Subtract Fractions",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "1/4 + 2/4 = ?",
        "answers": [
          { "text": "3/4", "correct": true },
          { "text": "2/8", "correct": false },
          { "text": "1/2", "correct": false }
        ]
      },
      {
        "question": "3/8 + 4/8 = ?",
        "answers": [
          { "text": "7/8", "correct": true },
          { "text": "6/8", "correct": false },
          { "text": "5/8", "correct": false }
        ]
      },
      {
        "question": "5/6 - 2/6 = ?",
        "answers": [
          { "text": "3/6 or 1/2", "correct": true },
          { "text": "4/6", "correct": false },
          { "text": "1/6", "correct": false }
        ]
      },
      {
        "question": "2/3 + 1/3 = ?",
        "answers": [
          { "text": "3/3 or 1 whole", "correct": true },
          { "text": "2/6", "correct": false },
          { "text": "1/3", "correct": false }
        ]
      },
      {
        "question": "7/10 - 4/10 = ?",
        "answers": [
          { "text": "3/10", "correct": true },
          { "text": "5/10", "correct": false },
          { "text": "2/10", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "elapsedtime",
    "title": "Elapsed Time",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "School starts at 8:00 AM and ends at 3:00 PM. How much time has passed?",
        "answers": [
          { "text": "7 hours", "correct": true },
          { "text": "6 hours", "correct": false },
          { "text": "8 hours", "correct": false }
        ]
      },
      {
        "question": "A movie begins at 2:30 PM and ends at 4:00 PM. How long is the movie?",
        "answers": [
          { "text": "1 hour 30 minutes", "correct": true },
          { "text": "1 hour", "correct": false },
          { "text": "2 hours", "correct": false }
        ]
      },
      {
        "question": "A bus leaves at 9:15 AM and arrives at 10:45 AM. What is the elapsed time?",
        "answers": [
          { "text": "1 hour 30 minutes", "correct": true },
          { "text": "1 hour 15 minutes", "correct": false },
          { "text": "2 hours", "correct": false }
        ]
      },
      {
        "question": "If dinner starts at 5:45 PM and ends at 6:30 PM, how much time passed?",
        "answers": [
          { "text": "45 minutes", "correct": true },
          { "text": "30 minutes", "correct": false },
          { "text": "1 hour", "correct": false }
        ]
      },
      {
        "question": "You start homework at 6:10 PM and finish at 7:25 PM. How long did it take?",
        "answers": [
          { "text": "1 hour 15 minutes", "correct": true },
          { "text": "1 hour", "correct": false },
          { "text": "1 hour 30 minutes", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "angles",
    "title": "Angles",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What is the measure of a right angle?",
        "answers": [
          { "text": "90°", "correct": true },
          { "text": "45°", "correct": false },
          { "text": "120°", "correct": false }
        ]
      },
      {
        "question": "Which type of angle measures less than 90°?",
        "answers": [
          { "text": "Acute angle", "correct": true },
          { "text": "Right angle", "correct": false },
          { "text": "Obtuse angle", "correct": false }
        ]
      },
      {
        "question": "Which type of angle measures more than 90° but less than 180°?",
        "answers": [
          { "text": "Obtuse angle", "correct": true },
          { "text": "Acute angle", "correct": false },
          { "text": "Right angle", "correct": false }
        ]
      },
      {
        "question": "What tool is used to measure angles?",
        "answers": [
          { "text": "Protractor", "correct": true },
          { "text": "Ruler", "correct": false },
          { "text": "Compass", "correct": false }
        ]
      },
      {
        "question": "What is the point called where two rays meet to form an angle?",
        "answers": [
          { "text": "Vertex", "correct": true },
          { "text": "Corner", "correct": false },
          { "text": "Edge", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "lines",
    "title": "Lines",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "What is a line?",
        "answers": [
          { "text": "A straight path that extends in both directions", "correct": true },
          { "text": "A line with one endpoint", "correct": false },
          { "text": "A line that stops at both ends", "correct": false }
        ]
      },
      {
        "question": "What are perpendicular lines?",
        "answers": [
          { "text": "Two lines that intersect to form right angles", "correct": true },
          { "text": "Lines that never meet", "correct": false },
          { "text": "Lines that curve around a point", "correct": false }
        ]
      },
      {
        "question": "What are parallel lines?",
        "answers": [
          { "text": "Lines in a plane that do not intersect", "correct": true },
          { "text": "Lines that meet at one point", "correct": false },
          { "text": "Lines that form an angle", "correct": false }
        ]
      },
      {
        "question": "What is a ray?",
        "answers": [
          { "text": "A line that starts at one endpoint and goes on forever", "correct": true },
          { "text": "A line that stops at both ends", "correct": false },
          { "text": "Two lines that cross each other", "correct": false }
        ]
      },
      {
        "question": "What is a line segment?",
        "answers": [
          { "text": "Part of a line that has two endpoints", "correct": true },
          { "text": "A line that goes on forever", "correct": false },
          { "text": "Two lines that form a right angle", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "quadrilaterals",
    "title": "Quadrilaterals",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "How many sides does a quadrilateral have?",
        "answers": [
          { "text": "4", "correct": true },
          { "text": "3", "correct": false },
          { "text": "5", "correct": false }
        ]
      },
      {
        "question": "Which quadrilateral has four right angles and opposite sides that are equal?",
        "answers": [
          { "text": "Rectangle", "correct": true },
          { "text": "Trapezoid", "correct": false },
          { "text": "Rhombus", "correct": false }
        ]
      },
      {
        "question": "Which quadrilateral has all four sides equal and four right angles?",
        "answers": [
          { "text": "Square", "correct": true },
          { "text": "Rectangle", "correct": false },
          { "text": "Parallelogram", "correct": false }
        ]
      },
      {
        "question": "Which quadrilateral has two pairs of parallel sides?",
        "answers": [
          { "text": "Parallelogram", "correct": true },
          { "text": "Trapezoid", "correct": false },
          { "text": "Kite", "correct": false }
        ]
      },
      {
        "question": "What type of shape is a quadrilateral?",
        "answers": [
          { "text": "Polygon", "correct": true },
          { "text": "Circle", "correct": false },
          { "text": "Triangle", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "triangles",
    "title": "Triangles",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "How many sides does a triangle have?",
        "answers": [
          { "text": "3", "correct": true },
          { "text": "4", "correct": false },
          { "text": "2", "correct": false }
        ]
      },
      {
        "question": "What type of triangle has all three sides equal?",
        "answers": [
          { "text": "Equilateral triangle", "correct": true },
          { "text": "Isosceles triangle", "correct": false },
          { "text": "Scalene triangle", "correct": false }
        ]
      },
      {
        "question": "What type of triangle has one angle equal to 90 degrees?",
        "answers": [
          { "text": "Right triangle", "correct": true },
          { "text": "Obtuse triangle", "correct": false },
          { "text": "Acute triangle", "correct": false }
        ]
      },
      {
        "question": "What type of triangle has two sides equal?",
        "answers": [
          { "text": "Isosceles triangle", "correct": true },
          { "text": "Scalene triangle", "correct": false },
          { "text": "Equilateral triangle", "correct": false }
        ]
      },
      {
        "question": "What type of triangle has all sides of different lengths?",
        "answers": [
          { "text": "Scalene triangle", "correct": true },
          { "text": "Equilateral triangle", "correct": false },
          { "text": "Isosceles triangle", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "2timestable",
    "title": "2 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "2 × 3 = ?",
        "answers": [
          { "text": "6", "correct": true },
          { "text": "5", "correct": false },
          { "text": "8", "correct": false }
        ]
      },
      {
        "question": "2 × 5 = ?",
        "answers": [
          { "text": "10", "correct": true },
          { "text": "8", "correct": false },
          { "text": "12", "correct": false }
        ]
      },
      {
        "question": "2 × 7 = ?",
        "answers": [
          { "text": "14", "correct": true },
          { "text": "12", "correct": false },
          { "text": "16", "correct": false }
        ]
      },
      {
        "question": "2 × 9 = ?",
        "answers": [
          { "text": "18", "correct": true },
          { "text": "20", "correct": false },
          { "text": "16", "correct": false }
        ]
      },
      {
        "question": "2 × 12 = ?",
        "answers": [
          { "text": "24", "correct": true },
          { "text": "22", "correct": false },
          { "text": "26", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "3timestable",
    "title": "3 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "3 × 2 = ?",
        "answers": [
          { "text": "6", "correct": true },
          { "text": "5", "correct": false },
          { "text": "9", "correct": false }
        ]
      },
      {
        "question": "3 × 4 = ?",
        "answers": [
          { "text": "12", "correct": true },
          { "text": "9", "correct": false },
          { "text": "15", "correct": false }
        ]
      },
      {
        "question": "3 × 6 = ?",
        "answers": [
          { "text": "18", "correct": true },
          { "text": "15", "correct": false },
          { "text": "12", "correct": false }
        ]
      },
      {
        "question": "3 × 8 = ?",
        "answers": [
          { "text": "24", "correct": true },
          { "text": "27", "correct": false },
          { "text": "21", "correct": false }
        ]
      },
      {
        "question": "3 × 12 = ?",
        "answers": [
          { "text": "36", "correct": true },
          { "text": "30", "correct": false },
          { "text": "33", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "4timestable",
    "title": "4 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "4 × 3 = ?",
        "answers": [
          { "text": "12", "correct": true },
          { "text": "8", "correct": false },
          { "text": "16", "correct": false }
        ]
      },
      {
        "question": "4 × 5 = ?",
        "answers": [
          { "text": "20", "correct": true },
          { "text": "24", "correct": false },
          { "text": "16", "correct": false }
        ]
      },
      {
        "question": "4 × 7 = ?",
        "answers": [
          { "text": "28", "correct": true },
          { "text": "24", "correct": false },
          { "text": "30", "correct": false }
        ]
      },
      {
        "question": "4 × 9 = ?",
        "answers": [
          { "text": "36", "correct": true },
          { "text": "32", "correct": false },
          { "text": "40", "correct": false }
        ]
      },
      {
        "question": "4 × 12 = ?",
        "answers": [
          { "text": "48", "correct": true },
          { "text": "44", "correct": false },
          { "text": "42", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "5timestable",
    "title": "5 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "5 × 3 = ?",
        "answers": [
          { "text": "15", "correct": true },
          { "text": "10", "correct": false },
          { "text": "20", "correct": false }
        ]
      },
      {
        "question": "5 × 4 = ?",
        "answers": [
          { "text": "20", "correct": true },
          { "text": "15", "correct": false },
          { "text": "25", "correct": false }
        ]
      },
      {
        "question": "5 × 6 = ?",
        "answers": [
          { "text": "30", "correct": true },
          { "text": "25", "correct": false },
          { "text": "35", "correct": false }
        ]
      },
      {
        "question": "5 × 8 = ?",
        "answers": [
          { "text": "40", "correct": true },
          { "text": "35", "correct": false },
          { "text": "45", "correct": false }
        ]
      },
      {
        "question": "5 × 12 = ?",
        "answers": [
          { "text": "60", "correct": true },
          { "text": "55", "correct": false },
          { "text": "65", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "6timestable",
    "title": "6 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "6 × 3 = ?",
        "answers": [
          { "text": "18", "correct": true },
          { "text": "12", "correct": false },
          { "text": "24", "correct": false }
        ]
      },
      {
        "question": "6 × 4 = ?",
        "answers": [
          { "text": "24", "correct": true },
          { "text": "18", "correct": false },
          { "text": "30", "correct": false }
        ]
      },
      {
        "question": "6 × 5 = ?",
        "answers": [
          { "text": "30", "correct": true },
          { "text": "24", "correct": false },
          { "text": "36", "correct": false }
        ]
      },
      {
        "question": "6 × 7 = ?",
        "answers": [
          { "text": "42", "correct": true },
          { "text": "48", "correct": false },
          { "text": "36", "correct": false }
        ]
      },
      {
        "question": "6 × 9 = ?",
        "answers": [
          { "text": "54", "correct": true },
          { "text": "60", "correct": false },
          { "text": "48", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "7timestable",
    "title": "7 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "7 × 2 = ?",
        "answers": [
          { "text": "14", "correct": true },
          { "text": "12", "correct": false },
          { "text": "16", "correct": false }
        ]
      },
      {
        "question": "7 × 3 = ?",
        "answers": [
          { "text": "21", "correct": true },
          { "text": "24", "correct": false },
          { "text": "18", "correct": false }
        ]
      },
      {
        "question": "7 × 5 = ?",
        "answers": [
          { "text": "35", "correct": true },
          { "text": "28", "correct": false },
          { "text": "42", "correct": false }
        ]
      },
      {
        "question": "7 × 8 = ?",
        "answers": [
          { "text": "56", "correct": true },
          { "text": "63", "correct": false },
          { "text": "49", "correct": false }
        ]
      },
      {
        "question": "7 × 12 = ?",
        "answers": [
          { "text": "84", "correct": true },
          { "text": "77", "correct": false },
          { "text": "91", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "8timestable",
    "title": "8 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "8 × 2 = ?",
        "answers": [
          { "text": "16", "correct": true },
          { "text": "18", "correct": false },
          { "text": "14", "correct": false }
        ]
      },
      {
        "question": "8 × 3 = ?",
        "answers": [
          { "text": "24", "correct": true },
          { "text": "28", "correct": false },
          { "text": "32", "correct": false }
        ]
      },
      {
        "question": "8 × 5 = ?",
        "answers": [
          { "text": "40", "correct": true },
          { "text": "48", "correct": false },
          { "text": "56", "correct": false }
        ]
      },
      {
        "question": "8 × 7 = ?",
        "answers": [
          { "text": "56", "correct": true },
          { "text": "64", "correct": false },
          { "text": "48", "correct": false }
        ]
      },
      {
        "question": "8 × 12 = ?",
        "answers": [
          { "text": "96", "correct": true },
          { "text": "88", "correct": false },
          { "text": "104", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "9timestable",
    "title": "9 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "9 × 2 = ?",
        "answers": [
          { "text": "18", "correct": true },
          { "text": "16", "correct": false },
          { "text": "20", "correct": false }
        ]
      },
      {
        "question": "9 × 4 = ?",
        "answers": [
          { "text": "36", "correct": true },
          { "text": "32", "correct": false },
          { "text": "27", "correct": false }
        ]
      },
      {
        "question": "9 × 5 = ?",
        "answers": [
          { "text": "45", "correct": true },
          { "text": "40", "correct": false },
          { "text": "54", "correct": false }
        ]
      },
      {
        "question": "9 × 7 = ?",
        "answers": [
          { "text": "63", "correct": true },
          { "text": "72", "correct": false },
          { "text": "54", "correct": false }
        ]
      },
      {
        "question": "9 × 12 = ?",
        "answers": [
          { "text": "108", "correct": true },
          { "text": "99", "correct": false },
          { "text": "112", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "10timestable",
    "title": "10 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "10 × 2 = ?",
        "answers": [
          { "text": "20", "correct": true },
          { "text": "10", "correct": false },
          { "text": "30", "correct": false }
        ]
      },
      {
        "question": "10 × 4 = ?",
        "answers": [
          { "text": "40", "correct": true },
          { "text": "30", "correct": false },
          { "text": "50", "correct": false }
        ]
      },
      {
        "question": "10 × 6 = ?",
        "answers": [
          { "text": "60", "correct": true },
          { "text": "50", "correct": false },
          { "text": "70", "correct": false }
        ]
      },
      {
        "question": "10 × 8 = ?",
        "answers": [
          { "text": "80", "correct": true },
          { "text": "70", "correct": false },
          { "text": "90", "correct": false }
        ]
      },
      {
        "question": "10 × 12 = ?",
        "answers": [
          { "text": "120", "correct": true },
          { "text": "100", "correct": false },
          { "text": "110", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "11timestable",
    "title": "11 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "11 × 2 = ?",
        "answers": [
          { "text": "22", "correct": true },
          { "text": "21", "correct": false },
          { "text": "24", "correct": false }
        ]
      },
      {
        "question": "11 × 4 = ?",
        "answers": [
          { "text": "44", "correct": true },
          { "text": "42", "correct": false },
          { "text": "48", "correct": false }
        ]
      },
      {
        "question": "11 × 6 = ?",
        "answers": [
          { "text": "66", "correct": true },
          { "text": "64", "correct": false },
          { "text": "60", "correct": false }
        ]
      },
      {
        "question": "11 × 8 = ?",
        "answers": [
          { "text": "88", "correct": true },
          { "text": "80", "correct": false },
          { "text": "99", "correct": false }
        ]
      },
      {
        "question": "11 × 12 = ?",
        "answers": [
          { "text": "132", "correct": true },
          { "text": "121", "correct": false },
          { "text": "142", "correct": false }
        ]
      }
    ]
  },
  {
    "slug": "12timestable",
    "title": "12 Times Table",
    "gameType": "multipleChoice",
    "placeholderStyle": { "backgroundColor": "transparent" },
    "placeholderImage": "",
    "questions": [
      {
        "question": "12 × 2 = ?",
        "answers": [
          { "text": "24", "correct": true },
          { "text": "22", "correct": false },
          { "text": "26", "correct": false }
        ]
      },
      {
        "question": "12 × 4 = ?",
        "answers": [
          { "text": "48", "correct": true },
          { "text": "42", "correct": false },
          { "text": "52", "correct": false }
        ]
      },
      {
        "question": "12 × 6 = ?",
        "answers": [
          { "text": "72", "correct": true },
          { "text": "68", "correct": false },
          { "text": "78", "correct": false }
        ]
      },
      {
        "question": "12 × 8 = ?",
        "answers": [
          { "text": "96", "correct": true },
          { "text": "92", "correct": false },
          { "text": "100", "correct": false }
        ]
      },
      {
        "question": "12 × 12 = ?",
        "answers": [
          { "text": "144", "correct": true },
          { "text": "132", "correct": false },
          { "text": "156", "correct": false }
        ]
      }
    ]
  }, 
  
]

export default md4thMathQuizContent;
